import "jquery.initialize";
import Ads from "../javascripts/ads/Ads";
import AffiliateManager from "../javascripts/affiliate_manager";
import ComScore from "../javascripts/com_score";
import Prebid from "../javascripts/vendor/prebid3.12.0.js";

$(() => {
  Ads.run();
  AffiliateManager.run();
  ComScore.run();
});
